import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductShippingInformation extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateShippingInformation);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateShippingInformation);
  }

  /**
   * Updates the shipping information.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateShippingInformation = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newShippingInformation = event.detail.data.html.querySelector('product-shipping-information');

    if (!newShippingInformation) return;

    morph(this, newShippingInformation, { childrenOnly: true });
  };
}

if (!customElements.get('product-shipping-information')) {
  customElements.define('product-shipping-information', ProductShippingInformation);
}
